import { SupplierStorefrontV2GetResponseType } from "@sellar-io/api-v2/types";
import { useBasketContext } from "../../../../hooks";
import { useStockListOrderSummaryProps } from "../../useStockListOrderSummaryProps";

export const useCheckoutOrderSummary = ({
  supplierStorefront,
  order,
}: {
  supplierStorefront: SupplierStorefrontV2GetResponseType | undefined;
  order: ReturnType<typeof useBasketContext>["0"]["order"];
}) => {
  const priceTierDiscounts =
    supplierStorefront?.VolumeDiscounts?.PriceTierDiscounts ?? [];

  const priceTierOrderRules =
    supplierStorefront?.FulfillmentType.OrderRules?.PriceTierOrderRules ??
    supplierStorefront?.OrderRules?.PriceTierOrderRules ??
    [];

  const minimumOrderPrice =
    supplierStorefront?.FulfillmentType.OrderRules?.minimumOrderPrice ??
    supplierStorefront?.OrderRules?.minimumOrderPrice ??
    0;

  const freeDeliveryBasketSubtotal =
    supplierStorefront?.FulfillmentType.freeDeliveryBasketSubtotal ?? null;

  const { tax, apiValues, isDeliveryChargeCapped, discount, subTotal, total } =
    useStockListOrderSummaryProps({
      order,
      deliveryChargeRules:
        supplierStorefront?.FulfillmentType.DeliveryChargeRules,
      deliveryCharge: supplierStorefront?.FulfillmentType.charge,
      deliveryChargeCap: supplierStorefront?.FulfillmentType.deliveryChargeCap,
      fulfillmentTypeContainerDeliveryCharges:
        supplierStorefront?.FulfillmentType
          .FulfillmentTypeContainerDeliveryCharges,
      priceTierDiscounts,
      caseSizeRuleList: supplierStorefront?.CaseSizeRules.list ?? [],
      priceTierOrderRules,
      minimumOrderPrice,
      containerTypeDeliveryChargeRules:
        supplierStorefront?.FulfillmentType.ContainerTypeDeliveryChargeRules ??
        [],
      freeDeliveryBasketSubtotal,
    });

  return {
    deliveryCharge: apiValues.deliveryCharge,
    isDeliveryChargeCapped,
    subTotal,
    discount,
    tax,
    total,
    totalCharge: apiValues.price,
  };
};
